import Flag from 'vue-flagpack'
import Vue from 'vue';

Vue.use(Flag, {
    name: 'Flag'
})